"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeNodeIdToAnswerPathMap = serializeNodeIdToAnswerPathMap;
exports.deserializeNodeIdToAnswerPathMap = deserializeNodeIdToAnswerPathMap;
function serializeNodeIdToAnswerPathMap(nodeIdToAnswerPathMap) {
    return Array.from(nodeIdToAnswerPathMap.entries());
}
function deserializeNodeIdToAnswerPathMap(nodeIdToAnswerPath) {
    return new Map(nodeIdToAnswerPath);
}
